import React, { forwardRef } from "react";
import { bool, func, oneOf, string } from "prop-types";

import componentSizes from "../../../../constants/componentSizes";
import * as S from "./styled";

const DateInput = forwardRef(
  (
    { className, isValid, max, min, onChange, required, size, ...props },
    ref
  ) => (
    <S.DateInput
      ref={ref}
      className={className}
      isValid={isValid}
      max={max}
      min={min}
      onChange={onChange}
      require={required}
      size={size}
      {...props}
    />
  )
);

DateInput.propTypes = {
  className: string,
  isValid: bool,
  min: string,
  max: string,
  onChange: func,
  required: bool,
  size: oneOf([componentSizes.SM, componentSizes.MD, componentSizes.LG])
};

DateInput.defaultProps = {
  className: "",
  isValid: true,
  min: "",
  max: "",
  onChange: () => {},
  required: false,
  size: componentSizes.MD
};

DateInput.displayName = "DateInput";

export default DateInput;
